const Logo = () => {
    return (
        <a href={"/"}>
            <svg
                className="group overflow-visible transition-all duration-300 ease-out-cubic"
                width="120"
                viewBox="0 0 401 92"
                fill="currentColor"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path
                        id="s-parts"
                        d="M34.9,92C54,92,69.5,80.5,69.5,61.1C69.5,43,56,30.3,34.9,30.3v13.4c-9.7,0-16.9-4.3-16.9-13.1 c0-8.8,6.2-14,17.4-14c9.2,0,14.7,3.8,16.1,8.8h17C67.2,11.4,54,0,35,0C14.9,0,0.6,12.6,0.6,31c0,18.4,14.9,29.5,34.3,29.5V47.8 c10.3,0,17.4,4.6,17.4,13.7c0,9-7.2,14.1-17.3,14.1c-9.1,0-15.4-4-17.3-9.5H0C2.5,80.6,15.8,92,34.9,92z"
                        style={{opacity: 1}}
                    />
                    <g id="s-glyph" style={{opacity: 0}}>
                        <rect x="37.8" y="36.6" width="22.6" height="22.6"/>
                        <rect x="10.4" y="9.1" width="22.6" height="22.6"/>
                        <rect x="10.4" y="64" width="22.6" height="22.6"/>
                    </g>
                    <path
                        id="s-serif"
                        d="M34,91.9c-15.2,0-27.8-7.7-31.1-21l11.8-3.7c2.4,12.6,10.8,21,20.8,21c9.4,0,15.7-6.5,15.7-15.8 C51.3,45.8,5.7,55.6,5.7,24.3C5.7,9.8,16.7,0,33.7,0c13.4,0,25.7,7,29.5,19.4l-11.9,3.7C48.7,11.3,40.7,3.7,32,3.7 c-8.8,0-14.8,5.8-14.8,14.4c0,24,46.5,15.8,46.5,47.8C63.7,81.8,52.1,91.9,34,91.9z"
                        style={{opacity: 0}}
                    />
                    <path
                        id="s-sans"
                        d="M35.3,92c-10.4,0-18.8-2.4-25-7.3C4.1,79.9,0.9,73.3,0.9,65H13c0,5.7,2.1,10,6.2,13c4.1,2.9,9.5,4.4,16.2,4.4 c3,0,5.9-0.3,8.5-0.9c2.6-0.6,4.9-1.6,7-2.8c2.1-1.3,3.7-3,4.9-5.2c1.2-2.2,1.8-4.8,1.8-7.6c0-1.5-0.2-2.8-0.5-4 c-0.4-1.2-0.8-2.2-1.4-3.1c-0.5-0.9-1.4-1.7-2.5-2.5c-1.2-0.8-2.2-1.5-3.3-1.9c-1-0.5-2.5-1.1-4.6-1.7c-2-0.6-3.7-1.1-5.3-1.5 c-1.5-0.4-3.7-0.9-6.5-1.6c-2.2-0.5-4-0.9-5.3-1.3c-1.3-0.3-3-0.8-5-1.4s-3.6-1.1-4.9-1.6c-1.2-0.5-2.7-1.2-4.4-1.9 c-1.6-0.8-3-1.6-4-2.4c-1-0.8-2.1-1.8-3.1-2.9c-1.1-1.2-2-2.4-2.5-3.7c-0.6-1.2-1.1-2.7-1.5-4.3c-0.4-1.7-0.6-3.4-0.6-5.2 c0-7.4,3-13.5,9-18.2c5.9-4.6,13.7-7,23-7c9.8,0,17.8,2.4,24,7.3s9.3,11.3,9.3,19H56c0-5-2-9-6-12.1c-4-3.1-9.2-4.7-15.6-4.7 c-6,0-11,1.4-14.9,4s-5.9,6.4-5.9,11.4c0,1.4,0.2,2.6,0.5,3.7c0.4,1.1,0.8,2.1,1.4,2.9c0.6,0.8,1.4,1.7,2.6,2.4 c1.2,0.7,2.4,1.4,3.4,1.9c1.1,0.5,2.7,1.1,4.7,1.7c2.1,0.6,3.9,1.1,5.5,1.6c1.7,0.4,3.9,0.9,6.8,1.7c2.2,0.5,3.9,0.9,5.1,1.3 c1.2,0.3,2.9,0.7,4.9,1.3c2,0.6,3.6,1.1,4.8,1.6c1.2,0.5,2.5,1.1,4.2,1.9c1.6,0.8,2.9,1.5,3.8,2.4c0.9,0.8,2,1.8,3,2.9 c1.1,1.1,1.9,2.4,2.5,3.7c0.6,1.3,1,2.8,1.4,4.4c0.4,1.7,0.6,3.5,0.6,5.4c0,7.6-3,13.9-8.9,18.9C54.1,89.5,45.9,92,35.3,92z"
                        style={{opacity: 0}}
                    />
                </g>
                <g>
                    <polygon
                        id="t-default"
                        points="101,90 120.3,90 120.3,19.5 147.9,19.5 147.9,2.1 73.4,2.1 73.4,19.5 101,19.5"
                        style={{opacity: 1}}
                    />
                    <g id="t-glyph" style={{opacity: 0}}>
                        <rect x="99.8" y="35.3" width="21.7" height="21.7"/>
                        <rect x="126.1" y="9" width="21.7" height="21.7"/>
                        <rect x="73.5" y="61.7" width="21.7" height="21.7"/>
                    </g>
                    <path
                        id="t-serif"
                        d="M144.5,2.1l3,24h-1.7c-2.8-12.8-9.3-20.3-21.2-20.3h-7.3v73.2c0,6.6,2.9,8.7,10.7,9.5v1.8H93.4v-1.8 c7.9-0.8,10.7-2.9,10.7-9.5V5.8h-7.3c-11.8,0-18.5,7.5-21.2,20.3h-1.7l3-24C76.9,2.1,144.5,2.1,144.5,2.1z"
                        style={{opacity: 0}}
                    />
                    <path id="t-sans" d="M75.4,12.3V2.1h70.3v10.2h-29.4V90h-11.5V12.3H75.4z" style={{opacity: 0}}/>
                </g>
                <g>
                    <path
                        id="o-parts"
                        d="M192.9,92v-9c20.3,0,35.5-15.9,35.5-37h9.4c0-25-19.4-46-44.9-46c-27.4,0-45.1,19.1-45.1,46 C147.8,71,167.4,92,192.9,92z M220.5,46h-8.6c0,11.4-8.4,19.8-19,19.8v8.6c-15.5,0-26.7-12.9-26.7-28.3c0-16.7,10-28,26.7-28 C208.4,18,220.5,29.9,220.5,46z"
                        style={{opacity: 1}}
                    />
                    <g id="o-glyph" style={{opacity: 0}}>
                        <rect x="181.6" y="34.7" width="22.5" height="22.5"/>
                        <rect x="208.9" y="7.4" width="22.5" height="22.5"/>
                        <rect x="154.2" y="62.1" width="22.5" height="22.5"/>
                        <rect x="208.9" y="62.1" width="22.5" height="22.5"/>
                        <rect x="154.2" y="7.4" width="22.5" height="22.5"/>
                    </g>
                    <path
                        id="o-serif"
                        d="M191.8,91.8c-25.3,0-40.8-19.6-40.8-44.1C151,19.6,168.4,0,192.4,0c25.3,0,40.7,19.6,40.7,44.1 C233.1,72.2,215.9,91.8,191.8,91.8z M194.3,88.1c15.3,0,25-16.6,25-39.9c0.1-24.6-11.8-44.6-29.2-44.6c-15.4-0.1-25,16.4-25.1,39.9 C164.9,68.2,177,88.1,194.3,88.1z"
                        style={{opacity: 0}}
                    />
                    <path
                        id="o-sans"
                        d="M192.4,91.9c-8.1,0-15.3-1.9-21.6-5.8c-6.3-3.8-11.2-9.3-14.7-16.2c-3.5-7-5.2-15-5.2-24s1.7-17,5.2-23.9 c3.5-7,8.4-12.4,14.7-16.3S184.4,0,192.4,0c12.3,0,22.3,4.2,30.1,12.8C230.1,21.2,234,32.3,234,46s-3.8,24.7-11.5,33.2 C214.8,87.7,204.7,91.9,192.4,91.9z M181.1,79.6c3.6,1.6,7.4,2.4,11.4,2.4s7.8-0.8,11.4-2.4c3.6-1.6,6.8-3.8,9.5-6.8 c2.8-2.9,5-6.7,6.7-11.4c1.6-4.7,2.5-9.8,2.5-15.5s-0.8-10.8-2.5-15.5c-1.6-4.7-3.8-8.4-6.7-11.4c-2.8-2.9-6-5.2-9.5-6.8 s-7.4-2.4-11.4-2.4s-7.8,0.8-11.4,2.4c-3.6,1.6-6.8,3.8-9.6,6.8c-2.8,2.9-5,6.7-6.7,11.4c-1.6,4.7-2.4,9.8-2.4,15.5 s0.8,10.8,2.4,15.5c1.6,4.7,3.8,8.4,6.7,11.4S177.5,78,181.1,79.6z"
                        style={{opacity: 0}}
                    />
                </g>
                <g>
                    <path
                        id="r-default"
                        d="M297.8,32.5c0,9-4.9,13.4-14.2,13.4h-17.8V19.6H283C292.3,19.6,297.8,23.5,297.8,32.5z M246.8,90h19.1V63.3 h17.8c1.1,0,2.1-0.1,3.2-0.1L300.7,90h20.4L304,57.8c8.1-5.6,12.1-14.8,12.1-25.2c0-17-10.4-30.4-33.1-30.4h-36.2V90z"
                        style={{opacity: 1}}
                    />
                    <g id="r-glyph" style={{opacity: 0}}>
                        <rect x="270.2" y="32.4" width="22.8" height="22.8"/>
                        <rect x="242.4" y="60.2" width="22.8" height="22.8"/>
                        <rect x="297.9" y="60.2" width="22.8" height="22.8"/>
                    </g>
                    <path
                        id="r-serif"
                        d="M308.8,80.2c2.8,4.3,7.9,7.5,12.4,7.9v1.8h-23.2c-0.5-2.4-1.9-4.6-3.4-6.9l-20.3-31.6h-8.8v27.3 c0,7.2,3.4,8.8,10.5,9.5V90h-34.3v-1.8c7.2-0.7,10.7-2.3,10.7-9.5V13.5c0-7.1-3.5-8.8-10.7-9.5V2.2h35.1c19.2,0,31.9,8.1,31.9,24.7 c0,12.7-7.7,20.4-20.1,23.2L308.8,80.2z M265.9,5.9l-0.1,41.8h9.6c13,0,19.8-8.4,19.8-20.7c0-12.5-6.9-21-19.8-21H265.9z"
                        style={{opacity: 0}}
                    />
                    <path
                        id="r-sans"
                        d="M285.4,2.2c9,0,15.9,2.4,21,7.2s7.7,11.5,7.7,20.3c0,6.2-1.3,11.4-3.9,15.7c-2.6,4.2-6.4,7.3-11.3,9.3l19,35.3 h-12.6l-17.1-32.9c-0.6,0.1-1.5,0.1-2.8,0.1h-26.8V90h-11.4V2.2H285.4z M284.4,12.3h-25.8v34.9h25.8c5.6,0,10-1.4,13.3-4.2 c3.2-2.8,4.9-7.2,4.9-13.2s-1.6-10.4-4.9-13.2C294.3,13.7,289.9,12.3,284.4,12.3z"
                        style={{opacity: 0}}
                    />
                </g>
                <g>
                    <path
                        id="y-parts"
                        d="M354.8,90h18.4V52.9L401,2.2h-21.2l-25,46.9V90z M338.7,40.6h20.7L338.7,2.2h-20.7L338.7,40.6z"
                        style={{opacity: 1}}
                    />
                    <g id="y-glyph" style={{opacity: 0}}>
                        <rect x="348.7" y="35.4" width="22.2" height="22.2"/>
                        <rect x="321.7" y="8.5" width="22.2" height="22.2"/>
                        <rect x="375.7" y="62.5" width="22.2" height="22.2"/>
                    </g>
                    <path
                        id="y-serif"
                        d="M344.8,90v-1.8c6.9-0.7,10.2-2.4,10.2-9.5V49.4l-19.6-34.1c-4.4-7.9-7.2-10.4-12.2-11.2V2.2h31.7 V4c-8.1,0.7-8.9,3.1-4.4,11.1l16.5,29l16.4-29c4.4-8,3-10.5-6.2-11.1V2.2h23.3V4c-5.8,0.8-8.7,3.3-13.1,11.1l-19.4,34.1v29.3 c0,7.1,3.4,8.8,10.3,9.5v1.8L344.8,90L344.8,90z"
                        style={{opacity: 0}}
                    />
                    <path id="y-sans" d="M400.9,2.2l-32.9,59.5V90h-11.5V61.7L323.8,2.2h12.7L362.3,50l25.9-47.8H400.9z"
                          style={{opacity: 0}}/>
                </g>
            </svg>
        </a>
    )
}

export {Logo}